import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";
import AuthFooter from "../../../components/AuthFooter/AuthFooter";
import PhoneStepForm from "../../../components/CreateAccount/PhoneStepForm";
import Heading from "../../../components/Heading/Heading";
import { RegisterFormContext } from "./RegisterFormContext";

/**
 * A component for the phone step in the registeration process.
 *
 * It is simply a wrapper around the PhoneStepForm component that provides it with the necessary values from the context
 *
 * @returns {JSX.Element}
 */

export default function PhoneStep() {
  const navigate = useNavigate();
  const { phoneStepSubmit } = useContext(RegisterFormContext);
  const { t } = useTranslation("global");

  const initialValues = {
    phone: "",
  };

  return (
    <>
      <div className="sm:w-screen w-full position relative">
        <div className="position absolute left-0 top-0">
          <img
            src="./assets/signin/left_vector.png"
            alt="left_vector"
            className="w-24 h-24 md:w-48 md:h-48"
          />
        </div>
        <div className="position absolute right-0 bottom-0">
          <img
            src="./assets/signin/right_vector.png"
            alt="right_vector"
            className="w-24 md:w-48 h-18 md:h-36"
          />
        </div>

        <div className="z-20 sm:w-screen w-full min-h-screen flex flex-row justify-center items-center">
          <div className="flex flex-col justify-center items-center">
            <button
              className="mb-4 cursor-pointer"
              onClick={() => navigate("/")}
            >
              <img
                src="./assets/header/LogoSVG.svg"
                alt="Moshrouk Trips"
                className="w-16 h-13"
              />
            </button>
            <div className="mt-4 block w-72 md:w-[480px] p-3 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
              <div className="w-auto md:w-96 text-center">
                <Heading
                  title={t("create_a_text")}
                  className={"text-2xl text-[#0E0E11]"}
                />
              </div>

              <div>
                <div className="p-2 md:p-4">
                  <PhoneStepForm
                    initialValues={initialValues}
                    phoneStepSubmit={phoneStepSubmit}
                  />
                </div>
              </div>
            </div>
            <div className="my-2">
              <AuthFooter />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
